/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Home_Store_System_Subtitle1Inputs */

const vi_sitesettings_home_store_system_subtitle1 = /** @type {(inputs: Sitesettings_Home_Store_System_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng phụ hệ thống cửa hàng`)
};

/**

* @param {Sitesettings_Home_Store_System_Subtitle1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_home_store_system_subtitle1 = /** @type {((inputs?: Sitesettings_Home_Store_System_Subtitle1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Home_Store_System_Subtitle1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_home_store_system_subtitle1(inputs)
});
export { sitesettings_home_store_system_subtitle1 as "siteSettings_home_store_system_subtitle" }